import clipboardCopy from 'clipboard-copy'

export const clipboard = {
  copy: clipboardCopy,
}
